const CameraUnlock = (): React.JSX.Element => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" fill="none" viewBox="0 0 22 16">
        <path stroke="#fff" strokeLinejoin="bevel" strokeWidth="1.5" d="M14.077 6.385V1H1v13.846h13.077V9.462m0-3.077L21 3.308v9.23l-6.923-3.076m0-3.077v3.077" />
        <path stroke="#fff" strokeWidth="1.5" d="M3.308 4.077h2.307" />
    </svg>
}

export default CameraUnlock